import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { useFormContext } from 'react-hook-form';

import { IncomeItem } from './IncomeItem.tsx';
import { incomeListOrder } from './incomeTypeConfig.ts';
import type { IncomeFormState } from '../hooks/useIncomeForm.ts';
import { useLeadDetailsFormContext } from '~/features/leadDetails/context/LeadDetailsFormContext.tsx';
import type { SchemaIncomeForm } from '~/features/leadDetails/schemas/income.schema.ts';

type Props = {
    applicant: 1 | 2;
    onDelete: IncomeFormState['onDelete'];
};

export const IncomeApplicant: React.FC<Props> = ({ applicant, onDelete }) => {
    const { watch } = useFormContext<SchemaIncomeForm>();
    const { addedRowIds } = useLeadDetailsFormContext();
    const attribution =
        applicant === 2 ? APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_2 : APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_1;
    const incomes = watch();

    const rows = incomeListOrder
        .flatMap((type) => (incomes[type] ?? []).map((income, index) => ({ ...income, index, type })))
        .filter((row) => row.gehoertZuAntragsteller === attribution)
        // Rows without an entry in addedRowIds score -1 and keep the order of incomeListOrder,
        // rows the user added in this session follow in the order the user added them.
        .sort((a, b) => addedRowIds.indexOf(a.id) - addedRowIds.indexOf(b.id));

    return (
        <div className="space-y-2">
            {rows.map(({ id, index, type }) => (
                <IncomeItem
                    key={id}
                    id={id}
                    index={index}
                    isSecondApplicant={applicant === 2}
                    onDelete={onDelete}
                    type={type}
                />
            ))}
        </div>
    );
};
